import { PERIOD } from '@/utils/enums/common';

export enum GET_LIMITS_USAGE_RANGE_TYPE {
    CURRENT_MONTH = 'CURRENT_MONTH',
    CURRENT_YEAR = 'CURRENT_YEAR',
    CUSTOM = 'CUSTOM',
}

export const PERIOD_USAGE_DESCRIPTION = {
    [PERIOD.YEAR]: 'translation_this_year',
    [PERIOD.MONTH]: 'translation_this_month',
    [PERIOD.WEEK]: 'translation_this_week',
    [PERIOD.SINGLE_USE]: 'requestDetails_usedLimit_title',
};
